import React from 'react';
import CTAButton from '../../shared/CTAButton';
import { useFadeUp } from '../../shared/useFadeUp';
import { bizCalendar, bizDashboard, bizJobList } from '../../../assets/v2';
import './businessTools.css';

const scrollToDownload = () =>
  document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });

const SMALL_TILES = [
  {
    title: 'Automated emails',
    desc: 'booking confirmations to delivery follow-ups',
  },
  { title: 'Client booking link', desc: 'your own scheduling page' },
  { title: 'Intake forms', desc: 'collect details before the job' },
];

const BusinessTools: React.FC = () => {
  const intro = useFadeUp<HTMLDivElement>();
  const row1 = useFadeUp<HTMLDivElement>();
  const row2 = useFadeUp<HTMLDivElement>();
  const cta = useFadeUp<HTMLDivElement>();

  return (
    <section className="v2-biz" id="business-tools" data-page-bg="#ffffff">
      <div className="v2-biz__container">
        <div
          ref={intro.ref}
          className={`v2-biz__intro fade-up ${intro.isVisible ? 'is-visible' : ''}`}
        >
          <h2 className="ui-h2">
            One Platform. From First Call to Final Report.
          </h2>
          <p className="ui-body">
            Manage intake, scheduling, payments, and reporting in one connected
            system. No switching tools. Everything flows through a single
            platform designed for home inspectors.
          </p>
        </div>

        <div
          ref={row1.ref}
          className={`v2-biz__row v2-biz__row--1 fade-up ${row1.isVisible ? 'is-visible' : ''}`}
        >
          <div className="v2-biz__tile v2-biz__tile--span4">
            <div className="v2-biz__media">
              <img
                src={bizCalendar}
                alt="Web calendar — month view"
                loading="lazy"
              />
            </div>
            <div className="v2-biz__cap">
              <div className="v2-biz__cap-title">Calendar</div>
              <div className="v2-biz__cap-desc">
                On-site or at the office. One calendar.
              </div>
            </div>
          </div>
          <div className="v2-biz__tile v2-biz__tile--span8">
            <div className="v2-biz__media">
              <img
                src={bizDashboard}
                alt="Dashboard — revenue, jobs, top agent"
                loading="lazy"
              />
            </div>
            <div className="v2-biz__cap">
              <div className="v2-biz__cap-title">Dashboard</div>
              <div className="v2-biz__cap-desc">
                Revenue, jobs booked, client pipeline — at a glance.
              </div>
            </div>
          </div>
        </div>

        <div
          ref={row2.ref}
          className={`v2-biz__row v2-biz__row--2 fade-up ${row2.isVisible ? 'is-visible' : ''}`}
        >
          <div className="v2-biz__tile v2-biz__tile--span8 v2-biz__tile--hero">
            <div className="v2-biz__media">
              <img
                src={bizJobList}
                alt="Job list — contract and payment status"
                loading="lazy"
              />
            </div>
            <div className="v2-biz__cap">
              <div className="v2-biz__cap-title">
                Job List — your day at a glance
              </div>
              <div className="v2-biz__cap-desc">
                See every job, what&apos;s signed, what&apos;s paid, and what
                still needs tracking.
              </div>
            </div>
          </div>
          <div className="v2-biz__stack v2-biz__tile--span4">
            {SMALL_TILES.map((t) => (
              <div key={t.title} className="v2-biz__tile v2-biz__tile--text">
                <div className="v2-biz__cap">
                  <div className="v2-biz__cap-title">{t.title}</div>
                  <div className="v2-biz__cap-desc">{t.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          ref={cta.ref}
          className={`v2-biz__cta fade-up ${cta.isVisible ? 'is-visible' : ''}`}
        >
          <CTAButton variant="blue" size="lg" onClick={scrollToDownload}>
            Run your first job free
          </CTAButton>
        </div>
      </div>
    </section>
  );
};

export default BusinessTools;
